var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[(_vm.currentPage)?_vm._l((_vm.routeIndex),function(child,index){return _c('div',{key:index},[_c('article-preview',{attrs:{"article":{
          fileContent: child.props.fileContent,
          urlPath: child.path,
        }}})],1)}):_vm._e(),_c('router-view'),_c('pager')],2)}
var staticRenderFns = []

export { render, staticRenderFns }